import { getTokenHeader } from "@/helpers/commonHelper";
import axios from "axios";
const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);
import _ from "lodash";

export default {
  async getPoiStatistics({ commit, state }, filter = {}) {
    try {
      const headers = getTokenHeader();
      if (headers) {
        const response = await axios.get(
          `${env.poi_api_client_url}statistics`,
          {
            headers,
            params: {
              principal_id: state.selectedPrincipal.id,
              ...filter
            }
          }
        );
        commit("SET_STATISTICS", response?.data ?? {});
      }
    } catch (e) {
      throw new Error(`API Error: ${e}`);
    }
  },
  async getCities({ commit, state }) {
    const headers = getTokenHeader();
    if (headers)
      try {
        const res = await axios.get(`${env.poi_api_client_url}cities`, {
          params: {
            currentPrincipal: state.selectedPrincipal.id
          },
          headers
        });
        commit("SET_CITIES", res?.data);
      } catch (ex) {
        throw new Error(`API Error: ${ex}`);
      }
    else throw new Error(`API Error: Headers missing`);
  },
  async getExportConfigs({ commit, state }, params) {
    const headers = getTokenHeader();
    if (headers) {
      const response = await axios.get(
        `${env.poi_api_client_url}exportConfig`,
        {
          params: {
            ...params,
            currentPrincipal: state.selectedPrincipal.id
          },
          headers
        }
      );
      const exportConfigs = response?.data?.data ?? [];
      const total = response?.data?.total ?? 0;

      commit("SET_EXPORT_CONFIG", exportConfigs);
      commit("SET_EXPORT_CONFIG_TOTAL", total);
    }
  },
  async getGlobalConfig(
    { commit, state },
    { principal, ignorePrincipal } = {}
  ) {
    const headers = getTokenHeader(),
      selectedPrincipal = principal || state.selectedPrincipal?.id;
    if (headers && selectedPrincipal)
      try {
        const config = {
          headers,
          params: {}
        };
        if (ignorePrincipal) config.params.ignorePrincipalId = "1";
        else config.params.currentPrincipal = selectedPrincipal;

        const response = await axios.get(
          `${env.poi_api_client_url}config/${selectedPrincipal}/`,
          config
        );

        commit("SET_GLOBAL_CONFIG", response?.data);
      } catch (ex) {
        throw new Error(`API Error: ${ex}`);
      }
    else throw new Error(`API Error: Headers missing`);
  },
  async getApiKeys({ commit, state }, query) {
    const headers = getTokenHeader();
    if (headers && state.selectedPrincipal?.id) {
      try {
        const response = await axios.get(`${env.poi_api_client_url}apiKey/`, {
          params: {
            ...query,
            principal: state.selectedPrincipal.id
          },
          headers
        });
        commit("SET_API_KEYS", response?.data);
      } catch (e) {
        await this.dispatch("createError", e);
      }
    }
  },
  async getCategories({ commit, state }) {
    const headers = getTokenHeader();
    if (headers) {
      const response = await axios.get(`${env.poi_api_client_url}category/`, {
        params: {
          currentPrincipal: state.selectedPrincipal.id
        },
        headers
      });
      const categories = response?.data
        ? _.sortBy(response?.data, "title")
        : [];
      commit("SET_CATEGORIES", categories);
    }
  },
  async getCategoriesByGroup({ commit, state }, categoryGroup) {
    const headers = getTokenHeader();
    if (headers) {
      const response = await axios.get(
        `${env.poi_api_client_url}categoryGroup/`,
        {
          params: {
            categoryGroup,
            currentPrincipal: state.selectedPrincipal.id
          },
          headers
        }
      );
      const categories =
        _.sortBy(
          _.flatten(
            response?.data?.map(categoryGroup => categoryGroup.categories)
          ),
          "title"
        ) ?? [];

      commit("SET_CATEGORIES", categories);
    }
  },
  async getMappingFields({ commit }) {
    const headers = getTokenHeader();
    if (headers) {
      const response = await axios.get(
        `${env.poi_api_client_url}mappingfields`,
        {
          headers
        }
      );
      const mappingFields = response?.data ?? [];
      commit("SET_MAPPING_FIELDS", mappingFields);
    }
  },
  async getCategoryGroups({ commit, state }, ignorePrincipal = false) {
    const headers = getTokenHeader();
    if (headers) {
      const params = {
        currentPrincipal: state.selectedPrincipal.id
      };
      if (ignorePrincipal) params.ignorePrincipalId = "1";
      const response = await axios.get(
        `${env.poi_api_client_url}categoryGroup/`,
        {
          params,
          headers
        }
      );
      const categoryGroups = response?.data ?? [];
      commit("SET_CATEGORY_GROUPS", categoryGroups);
    }
  },
  async getCategoryTypes({ commit, state }, ignorePrincipal = false) {
    const headers = getTokenHeader();
    if (headers) {
      const params = {
        currentPrincipal: state.selectedPrincipal.id
      };
      if (ignorePrincipal) params.ignorePrincipalId = "1";
      const response = await axios.get(
        `${env.poi_api_client_url}categoryType/`,
        {
          params,
          headers
        }
      );
      const categoryTypes = response?.data ?? [];
      commit("SET_CATEGORY_TYPES", categoryTypes);
    }
  },
  async getCategoryGroupsForType({ commit, state }, params) {
    const { categoryGroup, ignorePrincipal } = params;
    const headers = getTokenHeader();
    if (headers) {
      const response = await axios.get(
        `${env.poi_api_client_url}categoryGroup/`,
        {
          params: {
            ignorePrincipalId: ignorePrincipal ? "1" : null,
            currentPrincipal: state.selectedPrincipal.id,
            categoryGroup
          },
          headers
        }
      );
      const categoryGroups = response?.data ?? [];
      commit("SET_CATEGORY_GROUPS", categoryGroups);
    }
  },
  async updateCategoryGroup(props, catGroup) {
    const headers = getTokenHeader();
    try {
      const response = await axios.put(
        `${env.poi_api_client_url}categoryGroup/${catGroup._id}`,
        catGroup,
        {
          headers
        }
      );
      if (response.status === 200) {
        await this.dispatch("createSuccess", "Erfolgreich gespeichert!");
      } else
        await this.dispatch("createError", {
          errorMessage:
            "Update CategoryGroup failed with statusCode: " + response.status
        });
    } catch (err) {
      await this.dispatch("createError", err);
    } finally {
      await this.dispatch("getCategoryGroups", true);
    }
  },
  async getFeatureGroupsForPois({ commit, state }, ignorePrincipalId = false) {
    const headers = getTokenHeader();
    const params = {
      currentPrincipal: state.selectedPrincipal.id
    };

    if (ignorePrincipalId) params.ignorePrincipalId = "1";

    if (headers)
      try {
        const response = await axios.get(
          `${env.poi_api_client_url}featureGroup/`,
          {
            headers,
            params
          }
        );
        commit("SET_FEATURE_GROUPS", response?.data);
      } catch (ex) {
        throw new Error(`API Error: ${ex}`);
      }
    else throw new Error(`API Error: Headers missing`);
  },
  async getGlobalFeatureGroups({ commit, state }) {
    const headers = getTokenHeader();
    if (headers)
      try {
        const response = await axios.get(
          `${env.poi_api_client_url}featureGroup/`,
          {
            headers,
            params: {
              ignorePrincipalId: "1",
              currentPrincipal: state.selectedPrincipal.id
            }
          }
        );
        commit("SET_GLOBAL_FEATURE_GROUPS", response?.data);
      } catch (ex) {
        throw new Error(`API Error: ${ex}`);
      }
    else throw new Error(`API Error: Headers missing`);
  },
  async getRegions({ commit, state }, query) {
    const headers = getTokenHeader();
    if (headers)
      try {
        if (state.currentUser?.scopes?.includes("role:admin"))
          await this.dispatch("getPrincipals");
        const response = await axios.get(`${env.poi_api_client_url}region`, {
          headers,
          params: {
            ...query,
            principal_id: state.selectedPrincipal.id
          }
        });
        const regions = response?.data ?? [];
        if (!query?.listSearch) {
          regions.forEach(region => {
            region.principal = state.principals.find(principal => {
              return principal.id === region.principalId;
            });
          });
        }

        commit("SET_REGIONS", regions);
      } catch (ex) {
        throw new Error(`API Error: ${ex}`);
      }
    else throw new Error(`API Error: Headers missing`);
  },
  async updateRegion(store, region) {
    const headers = getTokenHeader();
    if (headers) {
      const response = await axios.put(
        `${env.poi_api_client_url}region/${region._id}`,
        region,
        {
          headers
        }
      );

      await store.dispatch("getRegions");
      return response;
    }
  },
  async createRegion(store, region) {
    const headers = getTokenHeader();
    if (headers) {
      const response = await axios.post(
        `${env.poi_api_client_url}region`,
        region,
        {
          headers
        }
      );

      await store.dispatch("getRegions");
      return response;
    }
  },
  async getPoisByRegion({ state, commit, dispatch }, filter = {}) {
    if (!state.currentUser) await dispatch("getCurrentUser");
    const { currentUser } = state;
    const headers = getTokenHeader();
    const regions = filter.regions?.length
      ? filter.regions
      : currentUser?.regions;

    // without regions the backend would return pois of all regions
    if (!regions?.length) return commit("SET_REGION_POIS", []);

    // one request per region (in parallel) keeps the single backend responses small
    const responses = await Promise.all(
      regions.map(region =>
        axios.get(`${env.poi_api_client_url}region/poi`, {
          headers,
          params: {
            ...filter,
            regions: [region]
          }
        })
      )
    );
    const res = responses.flatMap(response => response.data);

    res.sort((a, b) => a.title.localeCompare(b.title));

    commit("SET_REGION_POIS", res);
    res.forEach(poi => {
      if (!poi.state) poi.state = {};
    });

    res.sort((a, b) => a.title.localeCompare(b.title));

    commit("SET_REGION_POIS", res);
  }
};
